import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class chatIntentStore {

    // Properties

    @observable chatIntents = [];
    @observable chatIntentID = 0;
    @observable intentName = '';
    @observable intentRedirectName = '';
    @observable intentRedirectUrl = '';
    @observable answer = '';
    @observable isQna = true;
    @observable hasRedirectUrl = false;

    @observable showUpdateChatIntentModal = false;

    @observable itemSearchValue = '';

    @observable manageChatIntentTitle = '';

    @observable updateLoading = false;

    // Initialization

    @action initChatIntent() {
        this.setShowUpdateChatIntentModal(false);

        return ApiCaller.ChatIntent.apiGetChatIntents().then((chatIntentResponses) => {
            if (chatIntentResponses) {
                chatIntentResponses.map((chatIntentResponse) => {
                    return chatIntentResponse;
                })

                this.chatIntents = chatIntentResponses;
            } else {
                this.chatIntents = [];
            }

            this.updateLoading = false;
        })
    }

    @action initCreate() {
        this.manageChatIntentTitle = 'Add Chat Intent';

        this.chatIntentID = 0;
        this.intentName = '';
        this.intentRedirectName = '';
        this.intentRedirectUrl = '';
        this.answer = '';
        this.isQna = true;
        this.hasRedirectUrl = false;

        this.showUpdateChatIntentModal = true;
    }

    @action initUpdate(value) {
        this.chatIntentID = value;
        this.manageChatIntentTitle = 'Update Chat Intent';
        this.showUpdateChatIntentModal = true;

        return ApiCaller.ChatIntent.GetById(this.chatIntentID).then((response) => {
            this.chatIntentID = response.chatIntentID;
            this.intentName = response.intentName;
            this.intentRedirectName = response.intentRedirectName;
            this.intentRedirectUrl = response.intentRedirectUrl;
            this.answer = response.answer;
            this.isQna = this.answer !== '' && this.answer !== null;
            this.hasRedirectUrl = this.answer !== '' && this.intentRedirectUrl !== '/';
        })
    }

    @action initRead(id) {
        return ApiCaller.ChatIntent.GetById(id).then((response) => {
            if (response) {
                this.chatIntentID = response.chatIntentID;
                this.intentName = response.intentName;
                this.intentRedirectName = response.intentRedirectName;
                this.intentRedirectUrl = response.intentRedirectUrl;
                this.answer = response.answer;
            }
        })
    }

    // Transaction

    @action createChatIntent() {
        this.updateLoading = true;

        if (this.isQna) {
            this.intentRedirectUrl = null;
            this.intentRedirectName = null;
        } else {
            this.answer = null;
            
            if (!this.hasRedirectUrl) {
                this.intentRedirectUrl = '/';
            }
        }

        return ApiCaller.ChatIntent.apiCreateChatIntent(
            this.intentName,
            this.intentRedirectName,
            this.intentRedirectUrl,
            this.answer).then(() => {
                this.initChatIntent();
            })
    }

    @action updateChatIntent() {
        this.updateLoading = true;

        if (this.isQna) {
            this.intentRedirectUrl = null;
            this.intentRedirectName = null;
        } else {
            this.answer = null;
            
            if (!this.hasRedirectUrl) {
                this.intentRedirectUrl = '/';
            }
        }

        return ApiCaller.ChatIntent.Update(
            this.chatIntentID,
            this.intentName,
            this.intentRedirectName,
            this.intentRedirectUrl,
            this.answer).then(() => {
                this.initChatIntent();
            });
    }

    @action deleteChatIntent(chatIntentID) {
        return ApiCaller.ChatIntent.Delete(chatIntentID).then(() => {
            this.initChatIntent()
        })
    }

    @action setIntentName(value) {
        this.intentName = value;
    }

    @action setIntentRedirectName(value) {
        this.intentRedirectName = value;
    }

    @action setIntentRedirectUrl(value) {
        this.intentRedirectUrl = value;
    }

    @action setShowUpdateChatIntentModal(value) {
        this.showUpdateChatIntentModal = value;
    }

    @action setAnswer(value) {
        this.answer = value;
    }

    @action setIsQna(value) {
        this.isQna = value;
    }

    @action setHasRedirectUrl(value) {
        this.hasRedirectUrl = value;
    }
}

export default new chatIntentStore()
